import { Stack } from 'expo-router';
import React from 'react';

export default function LeafletingLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" />
      <Stack.Screen name="[roundId]" options={{ headerShown: false }} />
    </Stack>
  );
}
